import { constant } from '@medflex/commons';

const isSelf = ({ id }) => id === constant.selfContact.userId;

export default isSelf;
